import { trpc } from '@/shared/api';

interface PaymentStatusQueryOptions {
  readonly enabled?: boolean;
}

/** 결제 상태(payments.getStatus) — 성공 페이지의 "다시 확인"이 refetch 로 읽는다. */
export const usePaymentStatusQuery = (paymentId: string, options: PaymentStatusQueryOptions = {}) =>
  trpc.payments.getStatus.useQuery(
    { paymentId },
    { enabled: options.enabled ?? true, retry: false },
  );
